import statusActions from 'actions/status'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const fireCheckoutPendingEvent: CheckoutActionCreator =
  (pendingName, checkoutValue = true) =>
  (dispatch) => {
    dispatch(statusActions.pending(pendingName, checkoutValue))
  }
